import classNames from 'classnames';
import styles from './DownPointer.module.css';

type Props = {
  className?: string;
};

function DownPointer({ className }: Props) {
  return (
    <div
      className={classNames([className, styles.outer])}
    />
  );
}

export default DownPointer;
